<template>
    <ul v-if="showPills" class="tw-flex tw-flex-wrap tw-gap-2 sm:tw-gap-4 tw-text-xs sm:tw-text-sm tw-mb-2 xl:tw-mb-0 lg:tw-sticky lg:tw-top-0 lg:tw-z-30 dark:tw-bg-[#000C17] tw-bg-[#F9F9F9] tw-py-3 xl:tw-py-5">
        <li class="tw-flex tw-items-center tw-p-1.5 sm:tw-p-2 tw-rounded tw-border dark:tw-border-[#223F57] tw-bg-[#F2F2F2] dark:tw-bg-[#002039] dark:tw-text-white tw-font-semibold" 
            v-for="(pill, i) in pills"
            :key="i"    
        >
            {{ pill.item.key }} ({{ pill.item.value }})
            <button class="tw-text-[#000C17] dark:tw-text-white">
                <XIcon class="tw-h-[12px] sm:tw-h-[20px] tw-w-[12px] sm:tw-w-[20px] tw-ml-1" @click="handleCancel(`${pill.category},${pill.item.key}`)" />
            </button>
        </li>

        <li class="tw-flex tw-items-center tw-p-1.5 sm:tw-p-2 tw-rounded tw-border dark:tw-border-[#223F57] tw-bg-[#F2F2F2] dark:tw-bg-[#002039] dark:tw-text-white tw-font-semibold tw-uppercase">
            Clear all
            <button class="tw-text-[#000C17] dark:tw-text-white">
                <XIcon class="tw-h-[12px] sm:tw-h-[20px] tw-w-[12px] sm:tw-w-[20px] tw-ml-1" @click="handleClearFilters" />
            </button>
        </li>
    </ul>
</template>

<script setup>
    import { XIcon } from "@heroicons/vue/solid";
    import {computed, onBeforeMount} from "vue";

    const props = defineProps({
        multiSelectColumns: {
            type: Array,
            default: [],
        },
        selectedFilters: {
            type: Array,
            default: () => [],
        },
    })

    const emit = defineEmits(['cancelFilter', 'clearFilter']);

    const handleCancel = (category, item) => {
        emit('cancelFilter', category, item);
    }

    const handleClearFilters = () => {
        emit('clearFilter');
    }

    const pills = computed(() => {
        const pills = [];

        if (props.multiSelectColumns.length > 0) {
            props.multiSelectColumns.map((column) => {
                column.items && column.items.map((item) => {
                    const formattedColumn = column.category.replace( /\d+/, '');
                    //console.log('formattedColumn', `${formattedColumn},${item.key}`);
                    const isExist = props.selectedFilters.find(f => f === `${formattedColumn},${item.key}`);
                    if (isExist) pills.push({ category: formattedColumn, item});
                })
            })
        }

        return pills;
    })

    const showPills = computed(() => {
        return props.selectedFilters.length !== 0;
    })
</script>

<style scoped>

</style>
